import { render, staticRenderFns } from "./ParsingProducts.vue?vue&type=template&id=5ddc0222&scoped=true"
import script from "./ParsingProducts.vue?vue&type=script&lang=ts"
export * from "./ParsingProducts.vue?vue&type=script&lang=ts"
import style0 from "./ParsingProducts.vue?vue&type=style&index=0&id=5ddc0222&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddc0222",
  null
  
)

export default component.exports